var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('well',{attrs:{"severity":_vm.error ? 'warning' : ''}},[_c('p',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),(_vm.error)?_c('ul',[_c('li',[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e89f600","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
// module id = null
// module chunks = 